module.exports = __webpack_public_path__ + "img/13.756bf7c4.jpg";